import React from "react";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomSelect from "../../Shared/CustomSelect";
import {
  attendenceSection,
  classOptions,
  monthOption,
  sessionOption,
} from "../../utils/helpers";
import SubmitForm from "../../Shared/SubmitForm";
const Attendence = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Student Attendence</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Attendence</li>
        </ul>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Student Attendence</h3>
                </div>
                <Cta />
              </div>
              <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
                <div class="row">
                  <div class="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Select Class *"}
                      register={register}
                      errors={errors}
                      name={"class"}
                      placeholder={"Select Class"}
                      option={classOptions}
                    />
                  </div>
                  <div class="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Select Section *"}
                      register={register}
                      errors={errors}
                      name={"section"}
                      placeholder={"Select Section"}
                      option={attendenceSection}
                    />
                  </div>
                  <div class="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Select Month *"}
                      register={register}
                      errors={errors}
                      name={"month"}
                      placeholder={"Select Subject"}
                      option={monthOption}
                    />
                  </div>
                  <div class="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Select Session *"}
                      register={register}
                      errors={errors}
                      name={"session"}
                      placeholder={"Select Subject"}
                      option={sessionOption}
                    />
                  </div>

                  <SubmitForm />
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Attendence Sheet Of Class One: Section A, April 2019</h3>
                </div>
                <Cta />
              </div>
              <div class="table-responsive">
                <table class="table bs-table table-striped table-bordered text-nowrap">
                  <thead>
                    <tr>
                      <th class="text-left">Students</th>
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                      <th>18</th>
                      <th>19</th>
                      <th>20</th>
                      <th>21</th>
                      <th>22</th>
                      <th>23</th>
                      <th>24</th>
                      <th>25</th>
                      <th>26</th>
                      <th>27</th>
                      <th>28</th>
                      <th>29</th>
                      <th>30</th>
                      <th>31</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Michele Johnson</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Richi Akon</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td class="text-left">Amanda Kherr</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-times text-danger"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>
                        <i class="fas fa-check text-success"></i>
                      </td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attendence;
